import * as types from './actionTypes'

const initialState = {
    linkedOptions: {},
	filters: []
}

export default (state = initialState, action) => {
    switch (action.type) {
        case types.LINKED_OPTIONS_SUCCESS:
            return {
                ...state,
                linkedOptions: {
                    ...state.linkedOptions,
                    [action.id]: [...action.data]
                }
            }

        case types.LINKED_OPTIONS_FAILED:
            return {
                ...state
            }

		case types.FILTER_OPTIONS_FETCH:
			return {
				...state,
				isLoading: true
			}

		case types.FILTER_OPTIONS_SUCCESS:
			return {
				...state,
				filters: action.filters,
				isLoading: false
			}

		case types.FILTER_OPTIONS_FAILED:
			return {
				...state,
				isLoading: false
			}

		case types.FILTER_OPTIONS_RESET:
			return {
				...state,
				filters: []
			}

        default:
            return state
    }
}
